import { render, staticRenderFns } from "./StopL.vue?vue&type=template&id=50d819ba"
import script from "./StopL.vue?vue&type=script&lang=js"
export * from "./StopL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports